define('views/pages/trade/request/index',['require','views/base/view','views/pages/trade/request/navbar','views/pages/trade/request/summary','views/pages/trade/request/table','text!templates/pages/trade/request/index.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        TradeRequestNavbarView = require('views/pages/trade/request/navbar'),
        TradeRequestSummaryView = require('views/pages/trade/request/summary'),
        TradeRequestTableView = require('views/pages/trade/request/table'),
        template = require('text!templates/pages/trade/request/index.ejs');

    /*
        TRADE REQUEST PAGE
    */

    var TradeRequestView = View.extend({
        autoRender: true,
        template: template,
        className: 'tab-pane',
        id: 'trade-request-tab',
        region: 'trade-request-tab',
        regions: {
            'trade-request-table': '#trade-request-table-container',
            'trade-request-navbar': '#trade-request-navbar-container',
            'trade-request-summary': '#trade-request-summary-container'
        },
        listen: {
            'resize model': 'onResize',
            'change:page model': 'onPageChange'
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            this.$el[(this.model.get('page') === 'request') ? 'addClass' : 'removeClass']('active');

            var request = this.model.request;

            this.subview('navbar', new TradeRequestNavbarView({ model: request }));
            this.subview('table', new TradeRequestTableView({ collection: request.items, model: request }));
            this.subview('summary', new TradeRequestSummaryView({ model: request }));

            this.checkPage(this.model.get('page'));
        },
        checkPage: function(page) {
            if (page === 'request') {
                this.model.request.load();
            }
        },
        onPageChange: function(a, newPage) {
            this.checkPage(newPage);
        },
        onResize: function() {
            if (this.model.get('page') !== 'request') {
                return;
            }

            this.subview('table').onResize();
        }
    });

    return TradeRequestView;
});

